/**
 * Formats a location object into a single-line address string.
 *
 * @param {Object|null|undefined} location - Location object from the store data.
 * @param {string} [location.subThoroughfare] - Street number (e.g. "123").
 * @param {string} [location.thoroughfare]    - Street name (e.g. "Main St").
 * @param {string} [location.locality]        - City name.
 * @param {string} [location.administrativeArea] - State / province abbreviation.
 * @param {string} [location.postalCode]      - ZIP / postal code.
 * @returns {string} Comma-separated address string, or an empty string when
 *   the location is null/undefined or every field is empty. Callers should
 *   treat a falsy return value as "no displayable address" and hide any
 *   address-dependent UI (map embed, directions link, etc.).
 */
export function formatAddress(location) {
  if (!location) {
    return '';
  }

  const {
    subThoroughfare,
    thoroughfare,
    locality,
    administrativeArea,
    postalCode,
  } = location;

  const streetLine = [subThoroughfare, thoroughfare]
    .map(part => (typeof part === 'string' ? part.trim() : part))
    .filter(Boolean)
    .join(' ')
    .trim();

  const cityLine = typeof locality === 'string' ? locality.trim() : locality;
  const statePostal = [administrativeArea, postalCode]
    .map(part => (typeof part === 'string' ? part.trim() : part))
    .filter(Boolean)
    .join(' ')
    .trim();

  return [streetLine, cityLine, statePostal].filter(part => part && part.length > 0).join(', ');
}
